import eucerinLogo from 'assets/brands/eucerin.svg'
import generalElectricLogo from 'assets/brands/general electric.svg'
import johnsonLogo from 'assets/brands/johnson.svg'
import nestleLogo from 'assets/brands/nestle.svg'
import niveaLogo from 'assets/brands/nivea.svg'
import pepsiLogo from 'assets/brands/pepsi.svg'
import protectorLogo from 'assets/brands/protector.svg'
import skinLogo from 'assets/brands/skin.svg'
import hubspot from 'assets/links/hubspot.svg'
import intercom from 'assets/links/intercom.svg'
import looker from 'assets/links/looker.svg'
import optimizely from 'assets/links/optimizely.svg'
import salesforce from 'assets/links/salesforce.svg'
import { TFunction } from 'i18next'

interface PreviewBrand {
  readonly name: string
  readonly src: string
}

interface PreviewLink {
  readonly name: string
  readonly src: string
}

interface PreviewWorkItem {
  readonly title: string
  readonly description: string
  readonly breadCrumb: string
}

interface HomePreviewData {
  readonly brands: readonly PreviewBrand[]
  readonly links: readonly PreviewLink[]
  readonly workItems: readonly PreviewWorkItem[]
}

export const getHomePreviewData = ({ t }: { t: TFunction }): HomePreviewData => ({
  brands: [
    {
      name: t('home.brandsList.nivea'),
      src: niveaLogo,
    },
    {
      name: t('home.brandsList.generalElectric'),
      src: generalElectricLogo,
    },
    {
      name: t('home.brandsList.procterAndGamble'),
      src: protectorLogo,
    },
    {
      name: t('home.brandsList.johnsonAndJohnson'),
      src: johnsonLogo,
    },
    {
      name: t('home.brandsList.eucerin'),
      src: eucerinLogo,
    },
    {
      name: t('home.brandsList.nestle'),
      src: nestleLogo,
    },
    {
      name: t('home.brandsList.pepsiCo'),
      src: pepsiLogo,
    },
    {
      name: t('home.brandsList.skinStories'),
      src: skinLogo,
    },
  ],
  links: [
    {
      name: t('home.linksList.hubspot'),
      src: hubspot,
    },
    {
      name: t('home.linksList.intercom'),
      src: intercom,
    },
    {
      name: t('home.linksList.looker'),
      src: looker,
    },
    {
      name: t('home.linksList.optimizely'),
      src: optimizely,
    },
    {
      name: t('home.linksList.salesforce'),
      src: salesforce,
    },
    {
      name: t('home.linksList.kuphalGroup'),
      src: '',
    },
    {
      name: t('home.linksList.weber'),
      src: '',
    },
    {
      name: t('home.linksList.turnerBrothers'),
      src: '',
    },
  ],
  workItems: [
    {
      title: t('home.workItems.maximiseAudiences'),
      description: t('home.workItems.christmasYouth'),
      breadCrumb: t('home.workItems.unileverGermanyDietCoke'),
    },
    {
      title: t('home.workItems.campaignMonitor'),
      description: t('home.workItems.christmasParty'),
      breadCrumb: t('home.workItems.btGermanyEe'),
    },
    {
      title: t('home.workItems.maximiseCampaigns'),
      description: t('home.workItems.campaignGermanMarket'),
      breadCrumb: t('home.workItems.unileverGermanyDietCoke'),
    },
    {
      title: t('home.workItems.maximiseCampaigns'),
      description: t('home.workItems.italyGiro'),
      breadCrumb: t('home.workItems.ferreroGermanyNutella'),
    },
    {
      title: t('home.workItems.architectTouchpoints'),
      description: t('home.workItems.italyGiroNaples'),
      breadCrumb: t('home.workItems.ferreroGermanyNutella'),
    },
    {
      title: t('home.workItems.mediaPlanning'),
      description: t('home.workItems.promotionEuMarket'),
      breadCrumb: t('home.workItems.beiersdorfEuropeEucerin'),
    },
    {
      title: t('home.workItems.visionSettings'),
      description: t('home.workItems.campaignGermanMarket'),
      breadCrumb: t('home.workItems.unileverGermanyDietCoke'),
    },
    {
      title: t('home.workItems.maximiseCampaigns'),
      description: t('home.workItems.campaignUsMarket'),
      breadCrumb: t('home.workItems.btUsaEe'),
    },
  ],
})
